import React, { useState, useEffect , useRef } from 'react';
import CommonComponent from "../../CommonComponent";
import usePersistentDateRange from '../../Common/usePersistentDateRange';

const Settings = () => {

  const {
    selectedRange,
    handleDateChange,
    formattedStart,
    formattedEnd,
  } = usePersistentDateRange();

  return (
    <>
      <CommonComponent
        defaultRange={selectedRange}
        onRangeChange={handleDateChange}
      />

      <section className="section dashboard py-2">
      </section>
    </>
  );
};

export default Settings;
